export const MOBILE_S = '375px';
export const DEFAULT = '480px';
export const PAD_S = '768px';
export const PAD_L = '980px';
export const DESKTOP = '1280px';
export const XL = '1690px';
export const XXL = '1920px';
